export const getMaxCheckupDays = (line_items: ILineItem[] = [], defaultValue = 0) => {
  const checkupDays = line_items.map((line_item) => line_item.category?.checkupDays || 0)
  // reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/max#getting_the_maximum_element_of_an_array
  return checkupDays.reduce((a, b) => Math.max(a, b), defaultValue)
}

// returns a flat list of line items but adds sorting and nested levels
export const buildNestedStructure = (
  lineItems: ILineItem[],
  options: { flatList: boolean } = { flatList: true }
): ILineItem[] => {
  const sortedItems: (ILineItem | ISubItem)[] = []

  // Find and process parent items first
  for (const item of lineItems) {
    if (!item.lineItemId) {
      sortedItems.push(item)
      processChildren(item)
    }
  }

  function processChildren(parentItem: ILineItem) {
    for (const item of lineItems) {
      if (item.lineItemId && String(item.lineItemId) === String(parentItem.id)) {
        if (options.flatList) {
          sortedItems.push(item)
          processChildren(item)
        } else {
          // processChildren order needs to be different to first update value and push to the subitem list
          processChildren(item)
          parentItem.subItems = [...(parentItem.subItems || []), item]
        }
      }
    }
  }

  return sortedItems
}

export const subItemsWithFreeAttachment = (lineItem: ILineItem) =>
  (lineItem.subItems || []).filter((subItem) => subItem.freeAttachment)

export function filterByStatus(collection: ILineItem[], status: IFilterStatus, filter: boolean) {
  if (!filter) return collection
  const filterByStatus = ({ filterStatus }: ILineItem) => filterStatus === status

  return collection.filter(filterByStatus)
}
